import { baseDevelopEnvironment } from '@environments/_base/develop.environment';
import { EnvironmentSettings } from '../types';

export const environment: EnvironmentSettings = {
  ...baseDevelopEnvironment,
  firebase: {
    apiKey: 'AIzaSyBAziCwNww7WGFXh2hvQLD38B-Nr4QAYNI',
    appId: '1:1018643125835:web:aaaf38ae9af43a9c661fce',
    authDomain: 'pearsports-develop-291715.firebaseapp.com',
    measurementId: 'G-0YR85MX4YS',
    messagingSenderId: '1018643125835',
    projectId: 'pearsports-develop-291715',
    storageBucket: 'pearsports-develop-291715.appspot.com',
  },
};
